<div class='container'>
    <app-confirmation
    [view]="view"
    [detailMap]="detailMap"
    [appointment]="appointment"
    [makeModelYear]="makeModelYear">
    </app-confirmation>
</div>
